/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_JaInputs */

const en_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const es_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const de_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const zh_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const ar_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const fr_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const vi_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const sw_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const th_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const bs_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const ja_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const ko_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const pt_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const it_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const sv_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const nl_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const da_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const nb_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const fi_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const pl_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const ru_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const tr_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const hi_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const id_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const ms_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const cs_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const el_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const he_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const af_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

const hu_nav_language_ja = /** @type {(inputs: Nav_Language_JaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

/**
* | output |
* | --- |
* | "日本語" |
*
* @param {Nav_Language_JaInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_ja = /** @type {((inputs?: Nav_Language_JaInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_JaInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_ja(inputs)
	if (locale === "de") return de_nav_language_ja(inputs)
	if (locale === "zh") return zh_nav_language_ja(inputs)
	if (locale === "ar") return ar_nav_language_ja(inputs)
	if (locale === "fr") return fr_nav_language_ja(inputs)
	if (locale === "vi") return vi_nav_language_ja(inputs)
	if (locale === "sw") return sw_nav_language_ja(inputs)
	if (locale === "th") return th_nav_language_ja(inputs)
	if (locale === "bs") return bs_nav_language_ja(inputs)
	if (locale === "ja") return ja_nav_language_ja(inputs)
	if (locale === "ko") return ko_nav_language_ja(inputs)
	if (locale === "pt") return pt_nav_language_ja(inputs)
	if (locale === "it") return it_nav_language_ja(inputs)
	if (locale === "sv") return sv_nav_language_ja(inputs)
	if (locale === "nl") return nl_nav_language_ja(inputs)
	if (locale === "da") return da_nav_language_ja(inputs)
	if (locale === "nb") return nb_nav_language_ja(inputs)
	if (locale === "fi") return fi_nav_language_ja(inputs)
	if (locale === "pl") return pl_nav_language_ja(inputs)
	if (locale === "ru") return ru_nav_language_ja(inputs)
	if (locale === "tr") return tr_nav_language_ja(inputs)
	if (locale === "hi") return hi_nav_language_ja(inputs)
	if (locale === "id") return id_nav_language_ja(inputs)
	if (locale === "ms") return ms_nav_language_ja(inputs)
	if (locale === "cs") return cs_nav_language_ja(inputs)
	if (locale === "el") return el_nav_language_ja(inputs)
	if (locale === "he") return he_nav_language_ja(inputs)
	if (locale === "af") return af_nav_language_ja(inputs)
	if (locale === "hu") return hu_nav_language_ja(inputs)
	return en_nav_language_ja(inputs)
});